const emptyIter = (function* () {})();
export default function emptyL() {
  return emptyIter;
}
